import type { SurveyBundleDisplay, SurveyConfigBlockDisplay, SurveyDesignerSlice } from './types';

export { VALIDATION_ERROR_TYPE } from './types';

export const CURRENT_SCHEMA_VERSION = 1;

export const initialState: SurveyDesignerSlice = {
  activeBlockEditorTab: 'questions',
  activeSurveyConfigBlock: null,
  activeSurveyConfigBlockGroup: null,
  deletingSurveyConfigBlockGroupIds: {},
  invalidSurveyConfigBlocks: [],
  inputFocus: null,
  isBulkActionsMenuOpen: false,
  isDirectBlueprintReset: false,
  isProjectLocked: false,
  isSurveyConfigValid: true,
  isSkipLogicLoading: false,
  orderedSurveyConfigBlocks: [],
  projectId: null,
  scrollToSurveyConfigBlockId: null,
  solutionId: null,
  surveyBundlesDisplay: {},
  surveyConfigBlocksDisplay: {},
  surveyConfigBlocksSelection: {},
  surveyConfigBlockGroupsSelection: {},
  validationError: {
    hasError: false,
    validationErrorType: null,
  },
};

export const DEFAULT_SURVEY_CONFIG_BLOCK_DISPLAY: SurveyConfigBlockDisplay = {
  isExpanded: false,
};

export const DEFAULT_SURVEY_BUNDLE_DISPLAY: SurveyBundleDisplay = {
  isExpanded: true,
};
